import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/home-d.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Let Me <span className="blue"> Introduce </span> Myself
            </h1>
            <p className="home-about-body">
              I am loving and learning programming since I was in class 7.
              <br />
              <br />I am fluent in core fundamentals like
              <i>
                <b className="blue"> Python and Javascript. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building and deploying &nbsp;
              <i>
                <b className="blue">Web Applications </b> and
                also in trending areas related to{" "}
                <b className="blue">
                  Deep Learning and IoT.
                </b>
              </i>
              <br />
              <br />
              from past 2 years, I have strengthened various topics like <i><b className="blue">DS & Algo, React, Django, Flutter, Tensorflow, etc.</b></i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="blue">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Marmik2003"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/marmik-patel-82537516a/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
